import { render, staticRenderFns } from "./TransferStatusBadge.vue?vue&type=template&id=4d44e533&scoped=true"
import script from "./TransferStatusBadge.vue?vue&type=script&lang=js"
export * from "./TransferStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./TransferStatusBadge.vue?vue&type=style&index=0&id=4d44e533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d44e533",
  null
  
)

export default component.exports